import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { CryptoNewsBar } from './components/CryptoNewsBar';
import { HomePage } from './pages/HomePage';
import { CryptocurrenciesPage } from './pages/CryptocurrenciesPage';
import { ExchangesPage } from './pages/ExchangesPage';
import { CryptoDetailPage } from './pages/CryptoDetailPage';
import { ExchangeDetailPage } from './pages/ExchangeDetailPage';
import { SocialMediaPage } from './pages/SocialMediaPage';
import { RSSIntegrationPage } from './pages/RSSIntegrationPage';
import { TermsOfUsePage } from './pages/TermsOfUsePage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="flex flex-col min-h-screen pb-48" data-id="element-1">
        <Navbar data-id="element-2" />
        <main className="flex-1" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/cryptocurrencies" element={<CryptocurrenciesPage data-id="element-8" />} data-id="element-7" />
            <Route path="/exchanges" element={<ExchangesPage data-id="element-10" />} data-id="element-9" />
            <Route path="/cryptocurrency/:id" element={<CryptoDetailPage data-id="element-12" />} data-id="element-11" />
            <Route path="/exchange/:id" element={<ExchangeDetailPage data-id="element-14" />} data-id="element-13" />
            <Route path="/social-media" element={<SocialMediaPage data-id="element-16" />} data-id="element-15" />
            <Route path="/opportunities" element={<RSSIntegrationPage data-id="element-18" />} data-id="element-17" />
            <Route path="/terms-of-use" element={<TermsOfUsePage data-id="element-20" />} data-id="element-19" />
          </Routes>
        </main>
        <Footer data-id="element-21" />
        <CryptoNewsBar data-id="element-22" />
      </div>
    </BrowserRouter>;
}